import { render, staticRenderFns } from "./ViewMedicineItem.vue?vue&type=template&id=33e8dea2&scoped=true"
import script from "./ViewMedicineItem.vue?vue&type=script&lang=js"
export * from "./ViewMedicineItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e8dea2",
  null
  
)

export default component.exports